import { useQuery } from "@tanstack/react-query";
import { getAddedMembers } from "src/redux/api/_customer.api";

export const memberKeys = {
  all: ["members"] as const,
  list: (subscriptionId: number) =>
    [...memberKeys.all, "list", subscriptionId] as const,
};

export const useFetchMembers = (subscriptionId: number) => {
  return useQuery({
    queryKey: memberKeys.list(subscriptionId),
    queryFn: () => getAddedMembers(subscriptionId),
    enabled: Boolean(subscriptionId),
    staleTime: 1000 * 60 * 60 * 3, // 3 hours
    gcTime: 1000 * 60 * 60 * 3,
  });
};
